import { Stack } from "@mui/material";
import { CPLink, CPTitle } from "@warden-ui/common-components";
import { CPCard } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

interface CardContentTeamFindSentProps {
  email: string;
  onClickReenterEmail?: () => void;
  onClickResendEmail?: () => void;
  errorMessage?: string;
  loading?: boolean;
}

export const CardContentTeamFindSent = ({
  email = "",
  onClickReenterEmail,
  onClickResendEmail,
  ...props
}: CardContentTeamFindSentProps) => {
  const [ t ] = useTranslation();

  return (
    <CPCard>
      <Stack spacing={2}>
        <CPTitle
          title={t('team_find_complete.title')}
          hint={t('team_find_complete.hint', { email })}
        />

        <CPLink
          prefix={t('team_find_complete.content.reenter_prefix')}
          label={t('team_find_complete.content.reenter')}
          onClick={onClickReenterEmail} />

        <CPLink
          label={t('team_find_complete.content.resend')}
          onClick={onClickResendEmail} />
      </Stack>
    </CPCard>
  );
};
